import * as React from 'react';
 
global.tableName = '';
global.searchValue = '';
global.itemName = '';
global.itemWiki = ''; 
global.wikiLink = ''; 
